export default class ReplacementCandidate {
    private _turn: number;
    private _order: number;
    private _maskedNIF: string;
    private _status: number;
    private _reason: string | null;

    constructor(data) {
        this._turn = data.turn;
        this._order = data.order;
        this._maskedNIF = data.maskedNIF;
        this._status = data.replacementStatus;
        this._reason = data.replacementReasons || null;
    }
    
    public get turn() {
        return this._turn;
    }
    
    public get order() {
        return this._order;
    }

    public get maskedNIF() {
        return this._maskedNIF;
    }

    public get status() {
        return this._status;
    }

    public get reason() {
        return this._reason;
    }
}